export default [
  {
    path: '/',
    component: () => import('Homepage/Home.vue'),
  },
  {
    path: '/sobre',
    name: 'Sobre',
    component: () => import('Homepage/Sobre.vue'),
  },
  {
    path: '/contato',
    name: 'Contato',
    component: () => import('Homepage/Contato.vue'),
  },
  {
    path: '/produtos',
    component: () => import('Homepage/Produto.vue'),
    children: [
      {
        path: 'amerisolar',
        name: 'Amerisolar',
        component: () => import('Homepage/produtos/Amerisolar.vue'),
      },
      {
        path: 'dahsolar',
        name: 'Dahsolar',
        component: () => import('Homepage/produtos/Dahsolar.vue'),
      },
      {
        path: 'seraphim',
        name: 'Seraphim',
        component: () => import('Homepage/produtos/Seraphim.vue'),
      },
      {
        path: 'chint',
        name: 'Chint',
        component: () => import('Homepage/produtos/Chint.vue'),
      },
      {
        path: 'growatt',
        name: 'Growatt',
        component: () => import('Homepage/produtos/Growatt.vue'),
      },
      {
        path: 'saj',
        name: 'Saj',
        component: () => import('Homepage/produtos/Saj.vue'),
      },
      {
        path: 'canadian',
        name: 'Canadian',
        component: () => import('Homepage/produtos/Canadian.vue'),
      },
      {
        path: 'romagnole',
        name: 'Romagnole',
        component: () => import('Homepage/produtos/Romagnole.vue'),
      },
      {
        path: 'alumax',
        name: 'Alumax',
        component: () => import('Homepage/produtos/Alumax.vue'),
      },
      {
        path: 'clamper',
        name: 'Clamper',
        component: () => import('Homepage/produtos/Clamper.vue'),
      },
      {
        path: 'wise',
        name: 'Wise',
        component: () => import('Homepage/produtos/Wise.vue'),
      },
      {
        path: 'staubli',
        name: 'Staubli',
        component: () => import('Homepage/produtos/Staubli.vue'),
      },
      {
        path: 'sil',
        name: 'Sil',
        component: () => import('Homepage/produtos/Sil.vue'),
      },
    ],
  },
  { path: '*', component: () => import('Homepage/common/NaoEncontrada.vue') },
];
